module.exports = __webpack_public_path__ + "static/media/Instagram.6c0d5b0d.svg";